
import {
  SERVICES_NAME_SENDER_MULTI,
  FIRST_NAME_SENDER_MULTI,
  LAST_NAME_SENDER_MULTI,
  NATIONAL_CODE_SENDER_MULTI,
  POSTAL_CODE_SENDER_MULTI,
  MOBILE_NUMBER_SENDER_MULTI,
  PHONE_NUMBER_SENDER_MULTI,
  ADDRESS_SENDER_MULTI,
  EMAIL_SENDER_MULTI,
  COMPANY_SENDER_MULTI,
  LAT_SENDER_MULTI,
  LNG_SENDER_MULTI,
  CITY_NAME_SENDER_MULTI,
  CITY_ID_SENDER_MULTI,
  STATE_NAME_SENDER_MULTI,
  STATE_ID_SENDER_MULTI,
  NEED_SENDER_MULTI,
  SERVICES_SENDER_MULTI,
  FACTOR_SENDER_MULTI,
  NOTIFICATION_SENDER_MULTI,
  TRADEMARK_SENDER_MULTI,
  BREAKABLE_SENDER_MULTI,
  LIQUID_SENDER_MULTI,
  CARTOON_SENDER_MULTI,
  SELECTED_SERVICES_FROM_MAP_MULTI,
} from "../../Types";

export const setServicesSender = (payload) => {
  return {
    type: SERVICES_SENDER_MULTI,
    payload: payload,
  };
};
export const setServicesNameSender = (payload) => {
  return {
    type: SERVICES_NAME_SENDER_MULTI,
    payload: payload,
  };
};
export const setFirstNameSender = (payload) => {
  return {
    type: FIRST_NAME_SENDER_MULTI,
    payload: payload,
  };
};
export const setLastNameSender = (payload) => {
  return {
    type: LAST_NAME_SENDER_MULTI,
    payload: payload,
  };
};
export const setNationalCodeSender = (payload) => {
  return {
    type: NATIONAL_CODE_SENDER_MULTI,
    payload: payload,
  };
};
export const setPostalCodeSender = (payload) => {
  return {
    type: POSTAL_CODE_SENDER_MULTI,
    payload: payload,
  };
};
export const setAddressSender = (payload) => {
  return {
    type: ADDRESS_SENDER_MULTI,
    payload: payload,
  };
};
export const setMobileNumberSender = (payload) => {
  return {
    type: MOBILE_NUMBER_SENDER_MULTI,
    payload: payload,
  };
};
export const setPhoneNumberSender = (payload) => {
  return {
    type: PHONE_NUMBER_SENDER_MULTI,
    payload: payload,
  };
};
export const setCityNameSender = (payload) => {
  return {
    type: CITY_NAME_SENDER_MULTI,
    payload: payload,
  };
};
export const setCityIDSender = (payload) => {
  return {
    type: CITY_ID_SENDER_MULTI,
    payload: payload,
  };
};
export const setStateNameSender = (payload) => {
  return {
    type: STATE_NAME_SENDER_MULTI,
    payload: payload,
  };
};
export const setStateIDSender = (payload) => {
  return {
    type: STATE_ID_SENDER_MULTI,
    payload: payload,
  };
};
export const setLatSender = (payload) => {
  return {
    type: LAT_SENDER_MULTI,
    payload: payload,
  };
};
export const setLngSender = (payload) => {
  return {
    type: LNG_SENDER_MULTI,
    payload: payload,
  };
};
export const setEmailSender = (payload) => {
  return {
    type: EMAIL_SENDER_MULTI,
    payload: payload,
  };
};
export const setCompanySender = (payload) => {
  return {
    type: COMPANY_SENDER_MULTI,
    payload: payload,
  };
};
export const setNeedSender = (payload) => {
  return {
    type: NEED_SENDER_MULTI,
    payload: payload,

  };
};
export const setFactorSender = (payload) => {
  return {
    type: FACTOR_SENDER_MULTI,
    payload: payload,

  };
};
export const setNotificationSender = (payload) => {
  return {
    type: NOTIFICATION_SENDER_MULTI,
    payload: payload,

  };
};
export const setTrademarkSender = (payload) => {
  return {
    type: TRADEMARK_SENDER_MULTI,
    payload: payload,

  };
};
export const setBreakableSender = (payload) => {
  return {
    type: BREAKABLE_SENDER_MULTI,
    payload: payload,

  };
};
export const setLiquidSender = (payload) => {
  return {
    type: LIQUID_SENDER_MULTI,
    payload: payload,

  };
};
export const setCartoonSender = (payload) => {
  return {
    type: CARTOON_SENDER_MULTI,
    payload: payload,

  };
};
export const setSelectedServicesFromMap = (payload) => {
  return {
    type: SELECTED_SERVICES_FROM_MAP_MULTI,
    payload: payload,
  };
};